<template>
  <section class="w-full">
    <TopAppBar
      :leftBtnMode="leftBtnMode"
      :rightBtnMode="rightBtnMode"
      :title="title"
      :leftBtnMethod="leftBtnMethod"
      :rightBtnMethod="rightBtnMethod"
      staticMode="true"
    >
    </TopAppBar>
    <div class="pda-default">
      <div class="t-headline5">
        {{ $t("1213") }}
        <!-- 약관동의 -->
      </div>
      <div class="t-body3 mgt-6 t-color-content1">
        {{ $t("1214") }}
        <!-- 계속하면 아래 약관에 동의하는 것입니다. -->
      </div>

      <div v-show="isTerms" class="mdc-card mdc-elevation--z3 pda-default mgt-35">
        <div class="d-flex justify-content-between align-items-center">
          <div class="flex-grow-1">
            <router-link :to="{ name: 'Join2Terms' }">
              <span class="t-color-title t-subtitle3">
                {{ $t("1215") }}
                <!-- 서비스 이용약관 -->
              </span>
            </router-link>
          </div>

          <div class="mdc-form-field mdc-form-field--align-end">
            <div class="mdc-checkbox">
              <input
                type="checkbox"
                class="mdc-checkbox__native-control"
                v-model="checkTerms"
                @change="handleCheckAll1"
              />
              <div class="mdc-checkbox__background check-red">
                <svg class="mdc-checkbox__checkmark" viewBox="0 0 24 24">
                  <path
                    class="mdc-checkbox__checkmark-path"
                    fill="none"
                    d="M1.73,12.91 8.1,19.28 22.79,4.59"
                  />
                </svg>
                <div class="mdc-checkbox__mixedmark"></div>
              </div>
            </div>
            <label for="basic-checkbox t-button"></label>
          </div>
        </div>
        <router-link to="/terms">
          <div
            class="mgt-16 t-body3 h-60 scroll-y"
            v-html="htmlTermsOfService"
          ></div>
        </router-link>
        <div class="mgt-8 t-body3 t-color-BodygrayA">
          {{ $t("178", { str1: termsYear, str2: termsMonth, str3: termsDay }) }}
        </div>
      </div>

      <div v-show="isPrivacy" class="mdc-card mdc-elevation--z3 pda-default mgt-16">
        <div class="d-flex justify-content-between align-items-center">
          <div class="flex-grow-1">
            <router-link :to="{ name: 'Join2Privacy' }">
              <span class="t-color-title t-subtitle3">
                {{ $t("1216") }}
                <!-- 개인정보 보호정책 -->
              </span>
            </router-link>
          </div>

          <div class="mdc-form-field mdc-form-field--align-end">
            <div class="mdc-checkbox">
              <input
                type="checkbox"
                class="mdc-checkbox__native-control"
                v-model="checkPrivacy"
                @change="handleCheckAll2"
              />
              <div class="mdc-checkbox__background check-red">
                <svg class="mdc-checkbox__checkmark" viewBox="0 0 24 24">
                  <path
                    class="mdc-checkbox__checkmark-path"
                    fill="none"
                    d="M1.73,12.91 8.1,19.28 22.79,4.59"
                  />
                </svg>
                <div class="mdc-checkbox__mixedmark"></div>
              </div>
            </div>
            <label for="basic-checkbox t-button"></label>
          </div>
        </div>
        <router-link to="/privacy">
          <div
            class="mgt-16 t-body3 h-60 scroll-y"
            v-html="htmlPrivacypolicy"
          ></div>
        </router-link>

        <div class="mgt-8 t-body3 t-color-BodygrayA">
          {{
            $t("179", {
              str1: privacyYear,
              str2: privacyMonth,
              str3: privacyDay,
            })
          }}
        </div>
      </div>

      <hr class="divider mgt-16" />

      <div class="mdc-card mdc-elevation--z3 pda-default mgt-16">
        <div class="d-flex justify-content-between align-items-center">
          <div class="flex-grow-1">
            <span class="t-color-title t-subtitle3">
              {{ $t("1602") }}
              <!-- 전체 동의 -->
            </span>
          </div>

          <div class="mdc-form-field mdc-form-field--align-end">
            <div class="mdc-checkbox">
              <input
                type="checkbox"
                class="mdc-checkbox__native-control"
                v-model="checkAll"
                @change="handleCheckAll"
                :checked="validAgree"
              />
              <div class="mdc-checkbox__background check-red">
                <svg class="mdc-checkbox__checkmark" viewBox="0 0 24 24">
                  <path
                    class="mdc-checkbox__checkmark-path"
                    fill="none"
                    d="M1.73,12.91 8.1,19.28 22.79,4.59"
                  />
                </svg>
                <div class="mdc-checkbox__mixedmark"></div>
              </div>
            </div>
            <label for="basic-checkbox t-button"></label>
          </div>
        </div>
      </div>

      <div class="mgt-50">
        <button class="mdc-button mdc-button--raised btn-red" @click="next()">
          {{ $t("1218") }}
          <!-- 다음 -->
        </button>
      </div>
      <router-view></router-view>
    </div>
  </section>
</template>

<script>
/**
 * 회원가입 - 약관동의 컴포넌트(sign up - pp & tnu component)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define
import { MDCSelect } from "@material/select";
import { MDCFormField } from "@material/form-field";
import { MDCRadio } from "@material/radio";
import { MDCRipple } from "@material/ripple";
import joinApi from "@/api/joinApi.js";
import loginApi from "@/api/loginApi.js";
import memberApi from "@/api/memberApi.js";

import { mapState, mapMutations } from "vuex";

import TopAppBar from "@/components/TopAppBar.vue";
import { topAppBarMixin } from "../../mixins/topAppBar.js";
import { joinMixin } from "@/mixins/join.js";
import { commonMixin } from "@/mixins/common.js";

export default {
  data() {
    return {
      checkTerms: false,
      checkPrivacy: false,
      checkAll: false,
      htmlPrivacypolicy: null,
      htmlTermsOfService: null,

      privacyYear: null,
      privacyMonth: null,
      privacyDay: null,
      termsYear: null,
      termsMonth: null,
      termsDay: null,

      isPrivacy: false,
      isTerms: false,
      privacyDate: new Date(),
      termsDate: new Date(),

      params: "",
      redirectPath: "",
      popupData: null,
      popupImage: null,
      socialFirstName: "",
      socialLastName: "",
      socialFullName: "",
      socialEmail: "",
      socialAuth: false,
      isDrawerOpen: false,
      staticMode: "",
    };
  },

  mixins: [joinMixin, topAppBarMixin, commonMixin],

  components: {
    TopAppBar,
  },

  watch: {
    $route() {
      this.params = JSON.parse(localStorage.getItem("userParams"));
      this.setTopAppBarCloseOnly("");
    },
  },

  mounted() {
    this.params = JSON.parse(localStorage.getItem("userParams"));
    this.fetchMemberTerms();
  },

  computed: {
    ...mapState("join", {
      join: (state) => state,
    }),

    validAgree() {
      if(!this.isPrivacy) {
        return this.checkAll = this.checkTerms;
      } else if(!this.isTerms) {
        return this.checkAll = this.checkPrivacy;
      } else {
        this.checkAll = this.checkTerms && this.checkPrivacy;
        return this.checkAll;
      }
    },
  },

  methods: {
    // Store 변이 정의(define store mutation)
    ...mapMutations("join", [
      "SET_TERMS",
      "SET_JOINSTART",
      "SET_SOCIAL_LINK",
      "SET_NAME_FIRST",
      "SET_NAME_LAST",
      "SET_NAME_FULL",
      "SET_LOGINID",
      "SET_SOCIAL_ID",
      "INIT_JOIN_STORE",
    ]),

    setMaterialUi() {
      const buttonRipple = [].map.call(
        document.querySelectorAll(".mdc-button"),
        function (el) {
          let button = new MDCRipple.attachTo(el);
          return button;
        }
      );
    },

    handleCheckAll1() {
      this.checkTerms;
      this.checkPrivacy;
    },

    handleCheckAll2() {
      this.checkTerms;
      this.checkPrivacy;
    },

    // check all
    handleCheckAll() {
      if (this.checkAll) {
        this.checkTerms = true;
        this.checkPrivacy = true;
      } else {
        if(!this.isPrivacy) {
          this.checkPrivacy = true;
        }
        if(!this.isTerms) {
          this.checkTerms = true;
        }
        this.checkTerms = false;
        this.checkPrivacy = false;
      }
    },

    // next
    next() {
      if (this.checkAll) {
        let agreeDate = Date.now();
        let today = new Date();
        let agreeTime = today.getTime();

        let terms = { TERMS_OF_SERVICE: agreeTime, PRIVACY_STATEMENT: agreeTime};
        this.SET_TERMS(agreeDate);

        memberApi
          .termsAgree({ terms })
          .then((response) => {
            if (response.data.data === true) {
              this.checkSignInStatus();
            }
          })
          .catch((err) => {
            this.$router.push("/login");
          });
      } else {
        this.$snackOpen({
          contents: this.$t("946"), //모든 약관에 동의해 주세요.
          btnDisplay: "",
        }).then(() => {});
      }
    },

    fetchMemberTerms() {
      let responseData;
      memberApi.termsAgreeCheck().then((response) => {
        responseData = response.data.data;
        const privacyObj = _.filter(responseData, function(o) {
          return o.type.value === 'PRIVACY_STATEMENT'
        })
        const termsObj = _.filter(responseData, function(o) {
          return o.type.value === 'TERMS_OF_SERVICE'
        })

        if(privacyObj.length >= 1) {
          const privacyUrl = privacyObj[0].attachment.resourceUri;
          this.privacyDate = privacyObj[0].baseDate;
          this.isPrivacy = true;

          this.privacyYear = this.$moment(this.privacyDate).format("Y");
          this.privacyMonth = this.$moment(this.privacyDate).format("MM");
          this.privacyDay = this.$moment(this.privacyDate).format("DD");

          joinApi.policyContents(privacyUrl, "text").then((response) => {
            this.htmlPrivacypolicy = response.data;
          });
        }

        if(termsObj.length >= 1) {
          const termsUrl = termsObj[0].attachment.resourceUri;
          this.termsDate = termsObj[0].baseDate;
          this.isTerms = true;

          this.termsYear = this.$moment(this.termsDate).format("Y");
          this.termsMonth = this.$moment(this.termsDate).format("MM");
          this.termsDay = this.$moment(this.termsDate).format("DD");

          joinApi.policyContents(termsUrl, "text").then((response) => {
            this.htmlTermsOfService = response.data;
          });
        }
      })
    },

    checkSignInStatus() {
      let paramss = this.params;
      loginApi
        .login(paramss)
        .then((response) => {
          let responseData = response.data.data;
          let changePasswordRequest = responseData.changePasswordRequest;
          let reIssueChangePassword = responseData.reIssueChangePassword;
          let emailAuth = responseData.emailAuth;
          let dormancy = responseData.dormancy;
          let responsibilityAuth = responseData.responsibilityAuth;
          loginApi.setAuthInHeader(responseData.token);

          if (dormancy === true) {
            this.$alert({
              title: this.$t("824"),
              content:
                this.$t("825") +
                " " +
                this.$t("826") +
                "<br>" +
                this.$t("827", {
                  str:
                    '<a href="mailto:' +
                    BRAND_MANAGER_EMAIL +
                    '">' +
                    BRAND_MANAGER_EMAIL +
                    "</a>",
                }) +
                "<br>" +
                this.$t("828", {
                  str:
                    '<a href="tel:' +
                    BRAND_MANAGER_PHONE +
                    '">' +
                    BRAND_MANAGER_PHONE +
                    "</a>",
                }),
              accept: this.$t("829"),
            })
              .then(() => {
                this.$router.go(-1);
                //this.$router.push('/login')
              })
              .catch(() => {
                localStorage.removeItem("token");
                this.$router.push("/login");
                //this.$router.push('/resetpassword')
              });
          } else if (emailAuth === false) {
            this.$confirm({
              title: this.$t("804"),
              content: this.$t("805") + " " + this.$t("806"),
              accept: this.$t("835"),
              cancel: this.$t("834"),
            })
              .then(() => {
                this.$router.push("/emailvarification");
              })
              .catch(() => {
                localStorage.removeItem("token");
                this.$router.push("/login");
              });
          } else if (changePasswordRequest === true) {
            this.$router.push({ name: "MemberChangePassword" });
          } else if (reIssueChangePassword === true) {
            this.$router.push({ name: "MemberReIssueChangePassword" });
          }  else if (responsibilityAuth === false) {
            this.$alert({
              title: this.$t("830"),
              content: this.$t("831") + " " + this.$t("832"),
              accept: this.$t("833"),
            })
              .then(() => {
                this.$router.push("/verificationcode");
              })
              .catch(() => {
                //this.$router.push('/login')
              });
          } else {
            loginApi.setAuthInHeader(responseData.token);
            // Redirect URL

            this.redirectPath = this.$route.query.redirectPath || "/home";
            this.title = localStorage.getItem("brandName") || this.$t("286");
            this.callPushNotification();
            this.$router.push(this.redirectPath);
          }
        })
        .catch((err) => {
          console.log("LOGIN FLOW ERROR : ", err);
          const responseData = err.response.data.meta;
          if (responseData.errCode === 1201) {
            //관리자 승인 대기중(Waiting for administrator approval)
            // 매장 관리자 승인 대기중 입니다. 관리자에게 문의해주세요.
            //this.$snackOpen({contents: 'Todo 관리자 승인 대기중 입니다. 관리자에게 문의해주세요.', btnDisplayYN: false}).then(() => {})

            this.$alert({
              title: this.$t("779"), //가입 승인 대기 상태입니다.
              content:
                this.$t("780") +
                "<br>" +
                this.$t("781", {
                  str:
                    '<a href="mailto:' +
                    BRAND_MANAGER_EMAIL +
                    '">' +
                    BRAND_MANAGER_EMAIL +
                    "</a>",
                }) +
                "<br>" +
                this.$t("782", {
                  str:
                    '<a href="tel:' +
                    BRAND_MANAGER_PHONE +
                    '">' +
                    BRAND_MANAGER_PHONE +
                    "</a>",
                }),
              accept: this.$t("783"),
            })
              .then(() => {})
              .catch(() => {});
          } else if (responseData.errCode === 1202) {
            this.$alert({
              title: this.$t("779"), //가입 승인 대기 상태입니다.
              content:
                this.$t("780") +
                "<br>" +
                this.$t("781", {
                  str:
                    '<a href="mailto:' +
                    BRAND_MANAGER_EMAIL +
                    '">' +
                    BRAND_MANAGER_EMAIL +
                    "</a>",
                }) +
                "<br>" +
                this.$t("782", {
                  str:
                    '<a href="tel:' +
                    BRAND_MANAGER_PHONE +
                    '">' +
                    BRAND_MANAGER_PHONE +
                    "</a>",
                }),
              accept: this.$t("783"),
            })
              .then(() => {})
              .catch(() => {});
          } else if (responseData.errCode === 1204) {
            this.$alert({
              title: this.$t("1482"), //가입 승인 대기 상태입니다.
              content:
                this.$t("1483") +
                "<br>" +
                this.$t("1484") +
                ": " +
                '<a href="mailto:' +
                BRAND_MANAGER_EMAIL +
                '">' +
                BRAND_MANAGER_EMAIL +
                "</a>" +
                "<br>" +
                this.$t("1485") +
                ": " +
                '<a href="tel:' +
                BRAND_MANAGER_PHONE +
                '">' +
                BRAND_MANAGER_PHONE +
                "</a>",
              accept: this.$t("1486"),
            })
              .then(() => {})
              .catch(() => {});
          } else if (responseData.errCode === 1205) {
            this.$alert({
              title: this.$t("1914"), //가입 승인 대기 상태입니다.
              content:
                this.$t("1915") +
                " " +
                this.$t("1916") +
                "<br>" +
                this.$t("1917", {
                  str:
                    '<a href="mailto:' +
                    BRAND_MANAGER_EMAIL +
                    '">' +
                    BRAND_MANAGER_EMAIL +
                    "</a>",
                }) +
                "<br>" +
                this.$t("1918", {
                  str:
                    '<a href="tel:' +
                    BRAND_MANAGER_PHONE +
                    '">' +
                    BRAND_MANAGER_PHONE +
                    "</a>",
                }),
              accept: this.$t("1919"),
            })
              .then(() => {})
              .catch(() => {});
          } else if (responseData.errCode === 1105) {
            this.$alert({
              content: this.$t("1875"),
              accept: this.$t("1876"),
            })
              .then(() => {})
              .catch(() => {});
          } else if (responseData.errCode === 1335) {
            //아이디 계정 일시 정지(Suspend Account)
            // 로그인 정보가 5회 이상 일치하지 않아 30분간 로그인 정지되었습니다. 30분 후 다시 시도해주세요.
            this.$snackOpen({
              contents: this.$t("323"),
              btnDisplayYN: false,
            }).then(() => {});
          } else {
          }
        });
    },

    signOutFirebase() {
      firebase.auth().signOut();
    },
  },
};
</script>
